/**
 * viewAs.js — module-level bridge from ImpersonationContext (React) to the
 * plain-JS service wrappers (contacts.js, …).
 *
 * RW-187 impersonation never swaps the Firebase Auth uid (by design — see
 * ImpersonationContext.js), so server-authoritative callables can't infer
 * "view as" from the token. Services that should honor view-as read the
 * impersonated uid from here and pass it as `viewAsUid`; the server enforces
 * that only super_admin may re-scope (contactsApi), so a forged value from a
 * non-super_admin client is denied server-side.
 *
 * ImpersonationProvider is the ONLY writer.
 */
let viewAsUid = null;

export function setViewAsUid(uid) {
  viewAsUid = uid || null;
}

export function getViewAsUid() {
  return viewAsUid;
}
